module.exports = __webpack_public_path__ + "jihde_round-f47d5561a874e57744d9fe5b1f55b904.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/jihde_round.png
// module id = 1197
// module chunks = 1 2